const placeholders = [
  "Kotak", "IDFC", "HSBC", "Godrej", "Bechtel", "Wipro",
  "KPMG", "Tata", "HCL", "Tech M", "Birla", "Reliance",
  "Bosch", "GSK", "Fortis", "Havells",
];

const ClientCard = ({ name }) => (
  <div className="h-16 w-36 sm:w-44 flex-shrink-0 rounded-xl bg-card border border-border flex items-center justify-center px-4">
    <span className="font-display font-bold text-base text-muted-foreground">{name}</span>
  </div>
);

export default function Clients() {
  return (
    <section id="clients" className="py-16 lg:py-20" data-testid="clients-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-3">Our Valued Clients</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">
            Trusted by teams across <span className="text-bee-teal">20+ cities</span>
          </h2>
        </div>

        <div className="mt-10 overflow-hidden relative">
          <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
          <div className="flex gap-4 animate-marquee">
            {[...placeholders, ...placeholders].map((c, i) => (
              <ClientCard key={i} name={c} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
